export default __webpack_public_path__ + "static/media/mark.357dd985.png";